// Core
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';

// Chakra imports
import { Box } from '@chakra-ui/react';

// Components
import PosTransaction from './PosTransaction';
import PosTransactionDetails from './PosTransactionDetails';
import usePermissionStatusByKey from '../../../hooks/usePermissionStatusByKey';

function PosTransactions(props) {
  const { path } = useRouteMatch();

  const isPosTransactions = usePermissionStatusByKey(
    'GET:/admin/pos-transactions',
  );
  const isPosTransaction = usePermissionStatusByKey(
    'GET:/admin/pos-transactions/:id',
  );

  return (
    <>
      <Box>
        <Switch>
          {isPosTransaction && (
            <Route
              path={`${path}/:id`}
              render={() => <PosTransactionDetails />}
            />
          )}
          {isPosTransactions && (
            <Route path={`${path}`} render={() => <PosTransaction />} />
          )}
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default PosTransactions;
